import PropTypes from 'prop-types';
import React from 'react';
import history from 'modules/history';
import { Switch, Router, Route } from 'react-router-dom';
import config from 'config';
import LoggedRoutes from './LoggedRoutes';
import { useTasksNotifications } from 'modules/tasks/notifications/hook';
import LoginContainer from 'containers/LoginContainer';
import PasswordReset from 'containers/PasswordReset';
import { TabIcon } from 'assets/icons/icon_by_config/TabIcon';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';
import NewTicketNotifications from 'modules/emergencies/components/newTicketNotifications/newTicketNotifications';
import { SETTINGS } from 'modules/emergencies/constants';
import TokenHandler from '../LoginTenant/token';

const BASE_ROUTE = config.BASE_ROUTE;

const AppContainer = () => {
  let link = document.querySelector("link[rel~='icon']");

  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  link.href = TabIcon();
  document.title = getTenantPreLoginConfig().company_name;

  useTasksNotifications();

  localStorage.removeItem(SETTINGS.FILTERS_LOCAL_STORAGE_KEY);

  return (
    <>
      <Router history={history}>
        <>
          <NewTicketNotifications />
          <Switch>
            <Route path={`${BASE_ROUTE}login:redirect?`} component={LoginContainer} />
            <Route path={`${BASE_ROUTE}password_reset/:token?`} component={PasswordReset} />
            <Route path={`${BASE_ROUTE}saml`} component={TokenHandler} />
            <Route component={LoggedRoutes} />
          </Switch>
        </>
      </Router>
    </>
  );
};

AppContainer.propTypes = {
  initApp: PropTypes.func,
  appLoading: PropTypes.bool,
};

export const App = AppContainer;
